import DataGrid from "@components/DataGrid/DataGrid";
import { Box, Typography } from "@mui/material";
import { GridColDef, GridEventListener, GridRowEditStopReasons, GridRowModesModel, GridToolbar } from "@mui/x-data-grid-premium";
import React, { useState } from "react";
import { GridRowData } from "./ProfileDetailPanel";

export interface ProfileSettingsGridProps {
  title: string;
  columns: GridColDef[];
  rows: GridRowData[];
  showToolbar?: boolean;
  height?: number;
  onRowUpdate?: (updatedRow: GridRowData, originalRow: GridRowData) => void;
}

export const ProfileSettingsGrid: React.FC<ProfileSettingsGridProps> = ({ title, columns, rows, showToolbar = false, height = 300, onRowUpdate }) => {
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const processRowUpdate = (newRow: GridRowData, originalRow: GridRowData) => {
    if (onRowUpdate) {
      onRowUpdate(newRow, originalRow);
    }
    return newRow;
  };

  const handleRowEditStop: GridEventListener<"rowEditStop"> = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  return (
    <>
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Box sx={{ height: height, width: "100%" }}>
        <DataGrid
          columns={columns}
          rows={rows}
          getRowId={(row) => row.id}
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={setRowModesModel}
          onRowEditStop={handleRowEditStop}
          processRowUpdate={processRowUpdate}
          hideFooter
          density="compact"
          sx={{
            border: 1,
            borderColor: "divider",
            "& .MuiDataGrid-cell": {
              borderRight: 1,
              borderRightColor: "divider",
            },
          }}
          slots={showToolbar ? { toolbar: GridToolbar } : undefined}
          slotProps={
            showToolbar
              ? {
                  toolbar: {
                    showQuickFilter: true,
                  },
                }
              : undefined
          }
        />
      </Box>
    </>
  );
};

export default ProfileSettingsGrid;
